import ReactDOM from 'react-dom/client';
import { IoPersonAdd } from 'react-icons/io5';
import AvatarIcon from './AvatarIcon';

class ImageRenderer {
  element;

  constructor(props: any) {
    this.element = document.createElement('div');
    const root = ReactDOM.createRoot(this.element);
    /**
     * 수정자 : 홍선영
     * 날짜 : 2025.01.23
     * 수정내용 : 이미지캐싱 로직 업데이트
     *           기존에 randomString 생성해 url을 새롭게 만들어서 캐시를 무효화하여 매번 네트워크요청을 하는 방법 대신,
     *           이미지 url에 업데이트와 관련된 쿼리스트링을 붙인 채로 props.value 가져와서 부분적으로 이미지 캐싱을 사용하도록 수정함.
     *           e.g.) ${imageUrl}?v=${근로자번호}_${이미지업데이트시간}`
     */

    // const randomString = Math.random().toString(36).substring(7); // 랜덤 문자열을 쿼리스트링으로 추가해서 이미지 캐싱 방지

    const { rowKey } = props;
    const { aImg } = props.grid.store.data.filteredRawData[rowKey];
    if (props.value) {
      root.render(<img src={props.value} width='40px' height='40px' style={{ borderRadius: '5px' }} />);
    } else {
      root.render(<AvatarIcon />);
      // root.render(<IoPersonAdd size={25} />);
    }
  }

  getElement() {
    return this.element;
  }
}
export default ImageRenderer;
